import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = { class: "modal-footer flex-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_12 = { key: 1 }

import { ref, onMounted } from "vue";
import { ElForm } from "element-plus";
import { hideModal, showModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelForm',
  props: {
    title: {},
    submited: { type: Boolean },
    isLoading: { type: Boolean },
    saveTitle: {},
    savingTitle: {},
    discardTitle: {},
    discard: {},
    submit: {},
    elId: {},
    rules: {},
    formData: {},
    width: { default: 650 },
    submitColor: { default: "primary" },
    discardColor: { default: "light" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const formRef = ref<InstanceType<typeof ElForm>>();
const modelRef = ref<HTMLElement | null>(null);

const submitForm = () => {
  (formRef.value as InstanceType<typeof ElForm>).validate((valid) => {
    if (valid) {
      props.submit();
    }
  });
};

onMounted(() => {
  const model = document.getElementById(props.elId) as Node;
  document.body.appendChild(model);
});
const hide = () => {
  hideModal(modelRef.value);
};

const show = () => {
  showModal(modelRef.value);
};
__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    id: props.elId,
    ref_key: "modelRef",
    ref: modelRef
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", {
        [`mw-${props.width}px`]: _ctx.width,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElForm), {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (submitForm()), ["prevent"])),
          rules: props.rules,
          model: props.formData,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "modal-header",
              id: props.elId + 'header'
            }, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
              _createElementVNode("div", {
                id: props.elId + 'close',
                "data-bs-dismiss": "modal",
                class: "btn btn-icon btn-sm btn-active-icon-primary"
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
                ])
              ], 8, _hoisted_5)
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(`btn btn-${props.discardColor} me-3`),
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (props.discard && props.discard(...args)), ["prevent"]))
              }, _toDisplayString(props.discardTitle ? props.discardTitle : _ctx.$t("action.discard")), 3),
              _createElementVNode("button", {
                class: _normalizeClass(`btn btn-${props.submitColor} me-3`),
                type: "submit",
                disabled: props.submited || props.isLoading
              }, [
                (props.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.waiting")) + " ", 1),
                      _hoisted_11
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(props.saveTitle ? props.saveTitle : _ctx.$t("action.submit")), 1))
              ], 10, _hoisted_9)
            ])
          ]),
          _: 3
        }, 8, ["rules", "model"])
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})